<script>
    import { VBtn } from "vuetify/lib"
    export default {
        extends: VBtn,
        props: {
            elevation: {
                type: Number,
                default: 0,
            },
        },
    }
</script>
